
import React from 'react'
import { ArrowForward } from "@mui/icons-material"

import "./customicons.css"

export const ArrowForwardIconGray = ({onClick }) => {

  return (
   
    <div>
      <ArrowForward className = "arrowForwardIconGray" onClick = {onClick}/>
    
    </div> 

  )
}
  




